export default __webpack_public_path__ + "static/media/faq-img.624bb135.jpg";